import { defineComponent as _defineComponent } from 'vue';
import { computed } from 'vue';
export default /*#__PURE__*/_defineComponent({
  __name: 'index',
  props: {
    size: {
      type: String,
      default: 'md'
    },
    text: {
      type: String,
      default: ''
    },
    iconName: {
      type: String,
      default: null
    },
    type: {
      type: String,
      default: 'primary'
    },
    disabled: {
      type: Boolean,
      default: false
    },
    loading: {
      type: Boolean,
      default: false
    },
    width: {
      type: String,
      default: null
    },
    state: {
      type: String,
      default: 'primary'
    },
    hasHover: {
      type: Boolean,
      default: false
    },
    href: {
      type: String,
      default: ''
    },
    icon: {
      type: Boolean,
      default: false
    },
    stopPropogation: {
      type: Boolean,
      default: true
    },
    ellipses: {
      type: Boolean,
      default: true
    },
    maxWidth: {
      type: String,
      default: null
    },
    appendIcon: {
      type: String,
      default: null
    },
    rounded: {
      type: Boolean,
      default: false
    }
  },
  emits: ['click'],
  setup(__props, {
    emit
  }) {
    const props = __props;
    const buttonTypes = ['primary', 'outlined', 'text'];
    const buttonType = computed(() => {
      return buttonTypes.includes(props.type) ? props.type : 'primary';
    });
    const iconSize = computed(() => {
      if (props.size === 'xs') return 14;
      return props.size === 'sm' ? 16 : 18;
    });
    const getIconMargin = computed(() => {
      if (props.text === '') return 'mr-0';
      return props.size === 'sm' ? 'mr-1' : 'mr-2';
    });
    const clicked = eventObj => !props.stopPropogation && emit('click', eventObj);
    return {
      __sfc: true,
      props,
      buttonTypes,
      buttonType,
      iconSize,
      getIconMargin,
      emit,
      clicked
    };
  }
});